/* eslint-disable */
const LangMyAccount = {
	"myAccount._title": ["MY ACCOUNT", "TÀI KHOẢN CỦA TÔI"],
	"myAccount.copy._totalStarEarner": ["Total Stars Earned", "Tổng điểm ngôi sao"],
	"myAccount.copy._yourStarBalance": ["Your Star Balance", "Số dư Điểm Ngôi Sao"],
	"myAccount.copy._starsForRewardsRedemption": [
		"Stars for Rewards Redemption",
		"Điểm Ngôi Sao dùng để đổi thưởng",
	],
	"myAccount.copy._starsWillExpire": [
		"${stars} Star(s) will be expired on ${date}",
		"${stars} Điểm Ngôi Sao sẽ hết hạn vào ${date}",
	],

	"myAccount.copy._xLevel": ["${tierCode}", "${tierCode}"],
	"myAccount.copy._xLevel_Gold": ["Gold Tier", "Hạng thẻ Vàng"],
	"myAccount.copy._xLevel_Green": ["Green Tier", "Hạng thẻ Xanh"],
	"myAccount.copy._anniversaryDate": [
		"Anniversary Date <br /> ${date}",
		"Ngày kỷ niệm <br /> ${date}",
	],
	"myAccount.copy._xStarsUntilReward": [
		"You are ${stars} Stars away from <span class='color-secondary d-inline-block'>Gold Tier</span>",
		"Còn ${stars} điểm ngôi sao nữa để <span class='color-secondary d-inline-block'>hạng thẻ Vàng</span>",
	],
	"myAccount.copy._xStarsUntilFreeDrink": [
		"You are ${stars} Stars away from free drink.",
		"Còn ${stars} điểm ngôi sao nữa để nhận ly nước miễn phí.",
	],
	"myAccount.copy._xStarsToRetain": [
		"You are ${stars} Stars away to retain Gold Tier",
		"Còn ${stars} điểm ngôi sao nữa để gia hạng thẻ Vàng",
	],
	"myAccount.copy._earnStarsToUpgradeGold": [
		"Earn <span class='tier-copy-stars'>${stars} Star(s)</span> by <strong>${date}</strong> to upgrade <span class='tier-copy-gold'>Gold</span>",
		"Kiếm <span class='tier-copy-stars'>${stars} Điểm Ngôi Sao</span> trước <strong>${date}</strong> để nâng hạng <span class='tier-copy-gold'>Vàng</span>",
	],
	"myAccount.copy._earnStarsToMaintainGold": [
		"Earn <span class='tier-copy-stars'>${stars} Star(s)</span> by <strong>${date}</strong> to maintain <span class='tier-copy-gold'>Gold</span> for another year",
		"Kiếm <span class='tier-copy-stars'>${stars} Điểm Ngôi Sao</span> trước <strong>${date}</strong> để duy trì hạng <span class='tier-copy-gold'>Vàng</span> thêm 1 năm",
	],
	"myAccount.copy._extendXLevel": [
		"You are qualified to extend your <span class='color-secondary d-inline-block'>Gold Level</span> for 1 year.",
		"Bạn đã đủ điều kiện được duy trì <span class='color-secondary d-inline-block'>hạng thẻ Vàng </span> cho 1 năm.",
	],
	"myAccount.copy._congratulations": ["Congratulations!", "Xin chúc mừng!"],
	"myAccount.copy._goldStatusExtended": [
		"Gold status extended <br /> for 1 year until <strong>${date}</strong>",
		"Hạng Vàng được duy trì <br /> thêm 1 năm đến <strong>${date}</strong>",
	],
	"myAccount.copy._asOfXDate": ["AS OF ${date}", "ngày cập nhật gần nhất ${date}"],
}

export default LangMyAccount
